import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';

class SideBarAdmin extends Component {
  render() {
    const { t, onClickSideBar, userLevel, isAdminConfigTap, isMaintenanceTap, isReportTap } = this.props;
    console.log('isReportTap:', isReportTap);
    return (
        <div>

          <div className="sidebar-header text-center">
                {/* <h4>จัดการข้อมูล</h4> */}
                  <strong>{t('จัดการข้อมูล')}</strong>
              </div>
              <ul className=" components"  id="adminSidebar">

                  {isAdminConfigTap &&
                  <li className="menumini">
                    <a href="#homeSubmenu" data-toggle="collapse" aria-expanded="true" className="dropdown-toggle">
                      <i className="fa fa-cog"/>
                      <span>{t('ตั้งค่าข้อมูลหลัก')}</span>
                    </a>
                    <div className="menumini-div">
                      <ul className="collapse list-unstyled " id="homeSubmenu" data-parent="#adminSidebar">
                        <li onClick={() => onClickSideBar('userInfo')} className="sub-active ">

                          <a aria-expanded="false">{t('ข้อมูลผู้ใช้งาน')}<i className="hide-lg pull-right fa fa-user"/></a>

                        </li>
                        <li onClick={() => onClickSideBar('poiConfig')}>
                          <a>{t('จัดการข้อมูล POI')}<i className="hide-lg pull-right fa fa-map-marker"/></a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  }
                  {isAdminConfigTap &&
                  <li className="menumini">
                    <a href="#toolSubmenu" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                      <i className="fa fa-wrench"/>
                      <span>{t('เครื่องมือ')}</span>
                    </a>
                    <div className="menumini-div">
                      <ul className="collapse list-unstyled " id="toolSubmenu" data-parent="#adminSidebar">
                        <li onClick={() => onClickSideBar('viewTemporary')}>
                          <a>{t('ดูชั่วคราว')}<i className="hide-lg pull-right fa fa-low-vision"></i></a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  }
                   {/* owner */}
                  { (userLevel === 0 && isAdminConfigTap) &&
                    <li className="menumini">
                      <a href="#ownerSubmenu" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                        <i className="fa fa-user-secret"/>
                        <span>{t('เจ้าของระบบ')}</span>
                      </a>
                      <div className="menumini-div">
                      <ul className="collapse list-unstyled " id="ownerSubmenu"  data-parent="#adminSidebar">
                        <li onClick={() => onClickSideBar('adminInfo')}>
                          <a href="#">{t('ผู้ดูแลระบบ')}<i className="hide-lg pull-right fa fa-user" /></a>
                        </li>
                        <li onClick={() => onClickSideBar('dealerInfo')}>
                          <a href="#">{t('ข้อมูลตัวแทนจำหน่าย')}<i className="hide-lg pull-right fa fa-handshake-o" /></a>
                        </li>
                        <li onClick={() => onClickSideBar('customerInfo')}>
                          <a href="#">{t('ข้อมูลลูกค้า')}<i className="hide-lg pull-right fa fa-user" /></a>
                        </li>
                        <li onClick={() => onClickSideBar('employeeInfo')}>
                          <a href="#">{t('ข้อมูลพนักงาน')}<i className="hide-lg pull-right fa fa-user" /></a>
                        </li>
                        <li onClick={() => onClickSideBar('Drivers')}>
                          <a href="#">{t('พนักงานขับรถ')}<i className="hide-lg pull-right fa fa-id-card" /></a>
                        </li>
                        <li onClick={() => onClickSideBar('deviceInformation')}>
                          <a href="#">{t('ตั้งค่าเครื่อง')}<i className="hide-lg pull-right fa fa-sliders" /></a>
                        </li>
                        <li onClick={() => onClickSideBar('news')}>
                          <a href="#">{t('ข้อมูลข่าว')}<i className="hide-lg pull-right fa fa-newspaper-o" /></a>
                        </li>
                      </ul>
                      </div>
                    </li>
                  }

                  {/* admin */}
                  { (userLevel === 1 && isAdminConfigTap) &&
                  <li className="menumini">

                    <a href="#adminSubmenu" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                      <i className="fa fa-user"/>
                      <span>{t('ผู้ดูแลระบบ')}</span>
                    </a>
                    <div className="menumini-div">
                    <ul className="collapse list-unstyled " id="adminSubmenu" data-parent="#adminSidebar">
                      <li onClick={() => onClickSideBar('dealerInfo')}>
                        <a href="#">{t('ข้อมูลตัวแทนจำหน่าย')}<i className="hide-lg pull-right fa fa-handshake-o" /></a>
                      </li >
                      <li onClick={() => onClickSideBar('customerInfo')}>
                        <a href="#">{t('ข้อมูลลูกค้า')}<i className="hide-lg pull-right fa fa-user" /></a>
                      </li>
                      <li onClick={() => onClickSideBar('Drivers')}>
                        <a href="#">{t('พนักงานขับรถ')}<i className="hide-lg pull-right fa fa-id-card" /></a>
                        </li>
                     <li onClick={() => onClickSideBar('deviceInformation')}>
                        <a href="#">{t('ตั้งค่าเครื่อง')}<i className="hide-lg pull-right fa fa-sliders" /></a>
                     </li>
                      <li onClick={() => onClickSideBar('news')}>
                        <a href="#">{t('ข้อมูลข่าว')}<i className="hide-lg pull-right fa fa-newspaper-o" /></a>
                      </li>
                    </ul>
                    </div>
                  </li>

                  }


                  {/* dealer */}
                  {(userLevel === 2 && isAdminConfigTap) &&
                 <li className="menumini">
                      <a href="#dealerSubmenu" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                          <i className="fa fa-handshake-o"/>
                          <span>{t('ข้อมูลตัวแทนจำหน่าย')}</span>
                      </a>
                      <div className="menumini-div">
                      <ul className="collapse list-unstyled " id="dealerSubmenu"  data-parent="#adminSidebar">
                          <li onClick={() => onClickSideBar('customerInfo')}>
                            <a href="#">{t('ข้อมูลลูกค้า')}<i className="hide-lg pull-right fa fa-user" /></a>
                          </li>
                          <li onClick={() => onClickSideBar('deviceInformation')}>
                              <a href="#">{t('ตั้งค่าเครื่อง')}<i className="hide-lg pull-right fa fa-sliders" /></a>
                          </li>
                          <li>
                              <a href="#">{t('ข้อมูลตัวแทนจำหน่ายยรายย่อย')}<i className="hide-lg pull-right fa fa-users" /></a>
                          </li>
                          <li onClick={() => onClickSideBar('Drivers')}>
                          <a href="#">{t('พนักงานขับรถ')}<i className="hide-lg pull-right fa fa-id-card" /></a>
                          </li>
                          <li>
                              <a href="#">{t('ส่งคำสั่ง')}</a>
                          </li>
                      </ul>
                      </div>
                  </li>
                  }

                  {/* customer */}
                  {(userLevel === 3 && isAdminConfigTap) &&
                  <li className="menumini">
                      <a href="#customerSubmenu" data-toggle="collapse" aria-expanded="false"
                         className="dropdown-toggle">
                          <i className="fa fa-user"/>
                          <span>ลูกค้า</span>
                      </a>
                      <div className="menumini-div">
                      <ul className="collapse list-unstyled " id="customerSubmenu"  data-parent="#adminSidebar">
                          <li onClick={() => onClickSideBar('employeeInfo')}>
                              <a href="#">{t('ข้อมูลพนักงาน')}<i class="hide-lg pull-right fa fa-user" /></a>
                          </li>
                          <li onClick={() => onClickSideBar('Drivers')}>
                          <a href="#">{t('พนักงานขับรถ')}<i className="hide-lg pull-right fa fa-id-card" /></a>
                          </li>
                          <li onClick={() => onClickSideBar('deviceInformation')}>
                              <a href="#">{t('ตั้งค่าเครื่อง')}<i class="hide-lg pull-right fa fa-sliders" /></a>
                          </li>
                      </ul>
                      </div>
                  </li>
                  }

                  {/* employee */}
                  {(userLevel === 4 && isAdminConfigTap) &&
                  <li className="menumini">
                    <a href="#customerSubmenu" data-toggle="collapse" aria-expanded="false"
                       className="dropdown-toggle">
                      <i className="fa fa-user"/>
                      <span>{t('พนักงาน')}</span>
                    </a>
                    <div className="menumini-div">
                      <ul className="collapse list-unstyled " id="customerSubmenu"  data-parent="#adminSidebar">
                        <li onClick={() => onClickSideBar('Drivers')}>
                        <a href="#">{t('พนักงานขับรถ')}<i className="hide-lg pull-right fa fa-id-card" /></a>
                        </li>
                        <li onClick={() => onClickSideBar('deviceInformation')}>
                          <a href="#">{t('ตั้งค่าเครื่อง')}<i class="hide-lg pull-right fa fa-sliders" /></a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  }
                  {isAdminConfigTap &&
                  <li className="menumini">
                    <a href="#historySubmenu" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                      <i className="fa fa-history"/>
                      <span>{t('ประวัติการใช้งาน')}</span>
                    </a>
                    <div className="menumini-div">
                      <ul className="collapse list-unstyled " id="historySubmenu" data-parent="#adminSidebar">

                        <li onClick={() => onClickSideBar('accessLog')}>
                          <a href="#">{t('ประวัติการเข้าระบบ')}<i className="hide-lg pull-right fa fa-list-alt" /></a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  }
                  {isMaintenanceTap &&
                  <li className="menumini">
                    <a href="#maintenanceSubmenu" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                      <i className="fa fa-wrench"/>
                      <span>{t('ซ่อมบำรุง')}</span>
                    </a>
                    <div className="menumini-div">
                      <ul className="collapse list-unstyled " id="maintenanceSubmenu" data-parent="#adminSidebar">
                        <li onClick={() => onClickSideBar('maintenanceSummary')}>
                          <a href="#">{t('สรุปซ่อมบำรุง')}</a>
                        </li>
                        <li onClick={() => onClickSideBar('maintenanceฺInformation')}>
                              <a href="#">{t('เพิ่ม/แก้ไข รายการซ่อมบำรุง')}</a>
                         </li>
                          <li onClick={() => onClickSideBar('maintenanceTemplate')}>
                              <a href="#">{t('รายการแม่แบบ')}</a>
                          </li>
                      </ul>
                    </div>
                  </li>
                  }
                  {isReportTap &&
                  <li className="menumini">
                      <a href="#reportSubmenu" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                          <i className="fa fa-wrench"/>
                          <span>{t('รายงาน')}</span>
                      </a>
                      <div className="menumini-div">
                          <ul className="collapse list-unstyled " id="reportSubmenu" data-parent="#adminSidebar">
                              <li onClick={() => onClickSideBar('reportPortal')}>
                                  <a href="#">{t('รายงานทั้งหมด')}</a>
                              </li>
                          </ul>
                      </div>
                  </li>
                  }
              </ul>
        </div>
    );
  }
}

SideBarAdmin.defaultProps = {
    isMaintenanceTap: false,
    isReportTap: false
}

SideBarAdmin.propTypes = {
  onClickSideBar: PropTypes.func.isRequired,
  userLevel: PropTypes.number.isRequired,
  isMaintenanceTap: PropTypes.bool.isRequired,
  isAdminConfigTap: PropTypes.bool,
  isReportTap: PropTypes.bool
}

export default withNamespaces('Menubar')(SideBarAdmin);



// WEBPACK FOOTER //
// ./src/app/view/components/AdminConfig/SideBarAdmin.js